import ShipmentPage from './ShipmentPage';

export default ShipmentPage;
